import React, { Component } from "react";
import styled from "styled-components";

// Components
import Footer from "./Footer";
import NavBar from "./components/NavBar";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

// Styles
import "./App.css";

// Styled Components
const spacingForFooterHeight = "105px";
const PageContainerForFooter = styled.div`
  position: relative;
  min-height: 87vh;
  padding-bottom: ${spacingForFooterHeight};
`;

class App extends Component {
  render() {
    // const isIndexPage = window.location.pathname === '/'
    return (
      <MuiThemeProvider>
        <PageContainerForFooter>
          <NavBar />
          {this.props.children}
          {/* <Footer height={spacingForFooterHeight} /> */}
          <Footer />
        </PageContainerForFooter>
      </MuiThemeProvider>
    );
  }
}

export default App;
// {isIndexPage && <Footer />}



// WEBPACK FOOTER //
// ./src/App.js